export const ICON_INDIVIDUALS = "ri-account-circle-line";
export const ICON_CONTRACTS = "ri-exchange-dollar-fill"; //"ri-bank-card-line"; //
export const ICON_MDAS = "ri-bank-line";
export const ICON_USERS = "ri-group-line";
export const ICON_ASSESSMENTS = "ri-file-edit-line";
export const ICON_AGENCIES = "ri-earth-line";
export const ICON_CALENDAR = "ri-calendar-2-line";

export const APP_NAME_FULL = "Capacity Injection Reporting Tool";
export const APP_NAME_SHORT = "CIRT";

export const LEVEL_COUNTRY = "Country";
export const LEVEL_AGENCY = "Agency";

export const ROLE_RISK_ANALYST = "Risk Analyst";

export const CARD_MIN_HEIGHT = "62vh";

export const CLASSIFICATION_RESTRICTED: string = "Restricted";
export const CLASSIFICATION_CONFIDENTIAL: string = "Confidential";

export const VALID_GENDERS = ["Male", "Female", "Unspecified"];

export const COUNTRY_LEVEL = 100;

export const DEBOUNCE_TIME = 300;
